import React, { useContext } from 'react';
import { Card, CardBody } from 'reactstrap';
import { Skeleton } from 'primereact/skeleton';
import { BI_WS0000Context } from '../context';

import TrendChart from '../Graficos/TrendChart';
import TrendChartMulti from '../Graficos/TrendChartMulti';
import TrendDayChart from '../Graficos/TrendDayChart';
import BarChartY from '../Graficos/BarChartY';
import BarChartX from '../Graficos/BarChartX';
import BarChartXLine from '../Graficos/BarChartXLine';
import BarChartXMultiLine from '../Graficos/BarChartXMultiLine';
import ComposedCharts from '../Graficos/ComposedCharts';
import HeatMap from '../Graficos/HeatMap';
import MapChart from '../Graficos/MapChart';
import ScatterChart from '../Graficos/ScatterChart';
import LineChart from '../Graficos/LineChart';
import PieChart from '../Graficos/PieChart';

export default function GridAccordion({
  componentes,
  qtde,
  qtlLinha,
  alturaLinha,
  GridAutoRows
}) {
  
  const { isDataLoading } = useContext(BI_WS0000Context)

  if (!componentes || !Array.isArray(componentes)) return null;

  const visibleComponents = componentes.filter(item => {
    const { dadosComponente } = item;
    const hasNoData = !dadosComponente
      || (typeof dadosComponente === 'object' && !Array.isArray(dadosComponente) && Object.keys(dadosComponente).length === 0)
      || (Array.isArray(dadosComponente) && dadosComponente.length === 0)
      || JSON.stringify(dadosComponente).includes('<#')
    return !hasNoData;
  });

  const baseRowHeight = alturaLinha || 144;
  const autoRows = Math.ceil(visibleComponents.length / qtde);
  const containerStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(${qtde}, 1fr)`,
    ...(GridAutoRows === 'auto'
      ? { gridAutoRows: `minmax(${baseRowHeight}px, auto)` }
      : { gridTemplateRows: `repeat(${autoRows}, minmax(${baseRowHeight}px, auto))` }
    ),
    gap: '8px',
    width: '100%',
  };

  return (
    <div style={containerStyle}>
      {componentes.map(item => {
        const spanCols = item.Quantidade_Colunas_Componente || 1;
        const cellStyle = { gridColumn: `span ${spanCols}` };

        if (isDataLoading) {
          return (
            <div key={item.ID_Dashboard_Componente} style={cellStyle}>
              <Skeleton width="100%" height={alturaLinha || 200} />
            </div>
          );
        }

        const {
          Chave_Especificacao_Componente,
          dadosComponente,
          Sigla
        } = item;

        let valorIndicador = '-';
        if (
          dadosComponente &&
          typeof dadosComponente === 'object'
        ) {
          if (
            dadosComponente.success &&
            Array.isArray(dadosComponente.data) &&
            dadosComponente.data.length
          ) {
            valorIndicador = dadosComponente.data[0].Valor_Indicador;
          } else if (Array.isArray(dadosComponente) && dadosComponente.length) {
            valorIndicador = dadosComponente[0].Valor_Indicador;
          } else if (dadosComponente.valor != null) {
            valorIndicador = dadosComponente.valor;
          }
        }

        const renderFallback = () => (
          <Card className="card-dash-item">
            <CardBody className=" d-flex flex-column align-items-center justify-content-center">
              <div>{Sigla}</div>
              <div style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
                {valorIndicador}
              </div>
            </CardBody>
          </Card>
        );

        const hasNoData = !dadosComponente
          || (typeof dadosComponente === 'object' && !Array.isArray(dadosComponente) && Object.keys(dadosComponente).length === 0)
          || (Array.isArray(dadosComponente) && dadosComponente.length === 0)
          || JSON.stringify(dadosComponente).includes('<#')

        if (hasNoData) {
          return null;
        }
        
        const props = { item };

        let chartElement;
        switch (Chave_Especificacao_Componente) {
          case 'TrendChart':
            chartElement = <TrendChart {...props} />;
            break;
          case 'TrendChartMulti':
            chartElement = <TrendChartMulti {...props} />;
            break;
          case 'TrendDayChart':
            chartElement = <TrendDayChart {...props} />;
            break;
          case 'BarChartXLine':
            chartElement = <BarChartXLine {...props} />;
            break;
          case 'BarChartXMultiLine':
            chartElement = <BarChartXMultiLine {...props} />;
            break;
          case 'BarChartY':
            chartElement = <BarChartY {...props} />;
            break;
          case 'BarChartX':
            chartElement = <BarChartX {...props} />;
            break;
          case 'ComposedCharts':
            chartElement = <ComposedCharts {...props} />;
            break;
          case 'HeatMap':
            chartElement = <HeatMap {...props} />;
            break;
          case 'MapChart':
            chartElement = <MapChart {...props} />;
            break;
          case 'ScatterChart':
            chartElement = <ScatterChart {...props} />;
            break;
          case 'LineChart':
            chartElement = <LineChart {...props} />;
            break;
          case 'PieChart':
            chartElement = <PieChart {...props} />;
            break;
          default:
            return (
              <div key={item.ID_Dashboard_Componente} className="mw-100" style={cellStyle}>
                {renderFallback()}
              </div>
            );
        }

        return (
          <div key={item.ID_Dashboard_Componente} className="mw-100" style={cellStyle}>
            {chartElement}
          </div>
        );
      })}
    </div>
  );
}
